"use client";

import { useQuotesWatchlistSync } from "@/lib/quotes-watchlist";
import { useAccountConnection } from "@/lib/accounts/hooks";
import { useConnectDeepLink } from "@/lib/accounts/useConnectDeepLink";
import { useOrderModifyToasts } from "@/vybe-trader-client/order-modify";

export function AppInitializerContent({
  children,
}: {
  children: React.ReactNode;
}) {
  const {
    showErrorModal,
    errorMessageToShow,
    setShowErrorModal,
    setErrorMessageToShow,
  } = useAccountConnection();

  // Handle the "Open in terminal" email deep-link (?connect=…) → auto-add + connect the account.
  useConnectDeepLink();

  useQuotesWatchlistSync();
  useOrderModifyToasts();

  return (
    <>
      {children}

      {showErrorModal && errorMessageToShow && (
        <>
          <div
            className="fixed inset-0 bg-background/80 z-40"
            onClick={() => {
              setShowErrorModal(false);
              setErrorMessageToShow(null);
            }}
          />

          <div
            className="fixed inset-0 flex items-center justify-center z-50 px-4"
            onClick={() => {
              setShowErrorModal(false);
              setErrorMessageToShow(null);
            }}
          >
            <div
              className="bg-background border border-border rounded-2xl max-w-md w-full"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="p-6 pb-4">
                <div className="flex justify-center mb-4">
                  <div className="w-16 h-16 bg-red-500/20 rounded-full flex items-center justify-center">
                    <svg
                      className="w-8 h-8 text-red-500"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                  </div>
                </div>
                <h3 className="text-xl font-semibold text-foreground text-center">
                  Connection Issue
                </h3>
                <p className="text-muted-foreground text-center mt-2">
                  {errorMessageToShow}
                </p>
              </div>

              <div className="p-6 pt-0">
                <button
                  onClick={() => {
                    setShowErrorModal(false);
                    setErrorMessageToShow(null);
                  }}
                  className="w-full bg-red-500 hover:bg-red-600 text-foreground font-medium py-3 px-4 rounded-lg transition-colors"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}
